var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-component"},[_c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":require('@/assets/img/mall/no-order.png'),"alt":"empty"}}),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }